import * as THREE from './engines/three/three.module.js';


function initShaders()
{
    THREE.ShaderChunk[ 'pathtracing_uniforms_and_defines' ] = `

    
#ifndef USE_RAYTRACE
    #define PI               3.14159265358979323
#endif

    #define EPS_intersect    0.001
    #define TWO_PI           6.28318530717958648
    #define FOUR_PI          12.5663706143591729
    #define ONE_OVER_PI      0.31830988618379067
    #define ONE_OVER_TWO_PI  0.15915494309
    #define ONE_OVER_FOUR_PI 0.07957747154594767
    #define PI_OVER_TWO      1.57079632679489662
    #define ONE_OVER_THREE   0.33333333333333333
    #define E                2.71828182845904524
    #define INFINITY         1000000.0
    #define QUADRIC_EPSILON  0.00001
    #define SKYBOX -3
    #define SPOT_LIGHT -2
    #define POINT_LIGHT -1
    #define LIGHT 0
    #define DIFF 1
    #define REFR 2
    #define SPEC 3
    #define COAT 4
    #define CARCOAT 5
    #define TRANSLUCENT 6
    #define SPECSUB 7
    #define CHECK 8
    #define WATER 9
    #define PBR_MATERIAL 10
    #define WOOD 11
    #define SEAFLOOR 12
    #define TERRAIN 13
    #define CLOTH 14
    #define LIGHTWOOD 15
    #define DARKWOOD 16
    #define PAINTING 17
    #define METALCOAT 18
    #define TRUE 1
    #define FALSE 0
    `;

    THREE.ShaderChunk[ 'pathtracing_skymodel_defines' ] = `
    #define TURBIDITY 1.0
    #define RAYLEIGH_COEFFICIENT 3.0
    #define MIE_COEFFICIENT 0.03
    #define MIE_DIRECTIONAL_G 0.76
    // constants for atmospheric scattering
    #define THREE_OVER_SIXTEENPI 0.05968310365946075
    #define ONE_OVER_FOURPI 0.07957747154594767
    // wavelength of used primaries, according to preetham
    #define LAMBDA vec3( 680E-9, 550E-9, 450E-9 )
    #define TOTAL_RAYLEIGH vec3( 5.804542996261093E-6, 1.3562911419845635E-5, 3.0265902468824876E-5 )
    // mie stuff
    // K coefficient for the primaries
    #define K vec3(0.686, 0.678, 0.666)
    #define MIE_V 4.0
    #define MIE_CONST vec3( 1.8399918514433978E14, 2.7798023919660528E14, 4.0790479543861094E14 )
    // optical length at zenith for molecules
    #define RAYLEIGH_ZENITH_LENGTH 8400.0
    #define MIE_ZENITH_LENGTH 1250.0
    #define UP_VECTOR vec3(0.0, 1.0, 0.0)
    #define SUN_POWER 1000.0
    // 66 arc seconds -> degrees, and the cosine of that
    #define SUN_ANGULAR_DIAMETER_COS 0.9998 //0.9999566769
    #define CUTOFF_ANGLE 1.6110731556870734
    #define STEEPNESS 1.5
    `;


    THREE.ShaderChunk[ 'pathtracing_plane_intersect' ] = `
    //-----------------------------------------------------------------------
    float PlaneIntersect( vec4 pla, vec3 rayOrigin, vec3 rayDirection )
    //-----------------------------------------------------------------------
    {
        vec3 n = pla.xyz;
        float denom = dot(n, rayDirection);
        
            vec3 pOrO = (pla.w * n) - rayOrigin; 
            float result = dot(pOrO, n) / denom;
        return (result > 0.0) ? result : INFINITY;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_single_sided_plane_intersect' ] = `
    //----------------------------------------------------------------------------
    float SingleSidedPlaneIntersect( vec4 pla, vec3 rayOrigin, vec3 rayDirection )
    //----------------------------------------------------------------------------
    {
        vec3 n = pla.xyz;
        float denom = dot(n, rayDirection);
        if (denom > 0.0) return INFINITY;
        
            vec3 pOrO = (pla.w * n) - rayOrigin; 
            float result = dot(pOrO, n) / denom;
        return (result > 0.0) ? result : INFINITY;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_disk_intersect' ] = `
    //-------------------------------------------------------------------------------------------
    float DiskIntersect( float radius, vec3 pos, vec3 normal, vec3 rayOrigin, vec3 rayDirection )
    //-------------------------------------------------------------------------------------------
    {
        vec3 pOrO = pos - rayOrigin;
        float denom = dot(-normal, rayDirection);
        // use the following for one-sided disk
        //if (denom <= 0.0) return INFINITY;
        
            float result = dot(pOrO, -normal) / denom;
        if (result < 0.0) return INFINITY;
            vec3 intersectPos = rayOrigin + rayDirection * result;
        vec3 v = intersectPos - pos;
        float d2 = dot(v,v);
        float radiusSq = radius * radius;
        if (d2 > radiusSq)
            return INFINITY;
            
        return result;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_rectangle_intersect' ] = `
    //----------------------------------------------------------------------------------------------------------------
    float RectangleIntersect( vec3 pos, vec3 normal, float radiusU, float radiusV, vec3 rayOrigin, vec3 rayDirection )
    //----------------------------------------------------------------------------------------------------------------
    {
        float dt = dot(-normal, rayDirection);
        // use the following for one-sided rectangle
        if (dt < 0.0) return INFINITY;

        float t = dot(-normal, pos - rayOrigin) / dt;
        if (t < 0.0) return INFINITY;
        
        vec3 hit = rayOrigin + rayDirection * t;
        vec3 vi = hit - pos;
        vec3 U = normalize( cross( abs(normal.y) < 0.9 ? vec3(0, 1, 0) : vec3(0, 0, 1), normal ) );
        vec3 V = cross(normal, U);
        return (abs(dot(U, vi)) > radiusU || abs(dot(V, vi)) > radiusV) ? INFINITY : t;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_slab_intersect' ] = `
    //---------------------------------------------------------------------------------------------
    float SlabIntersect( float radius, vec3 normal, vec3 rayOrigin, vec3 rayDirection, out vec3 n )
    //---------------------------------------------------------------------------------------------
    {
        n = dot(normal, rayDirection) < 0.0 ? normal : -normal;
        float rad = dot(rayOrigin, n) > radius ? radius : -radius; 
        float denom = dot(n, rayDirection);
        vec3 pOrO = (rad * n) - rayOrigin; 
        float t = dot(pOrO, n) / denom;
        return t > 0.0 ? t : INFINITY;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_sphere_intersect' ] = `
    /* int solveQuadratic(float A, float B, float C, out float t0, out float t1)
    {
        float discrim = B * B - 4.0 * A * C;
        
        if (discrim < 0.0)
                return FALSE;
        
        float rootDiscrim = sqrt(discrim);
        float Q = (B > 0.0) ? -0.5 * (B + rootDiscrim) : -0.5 * (B - rootDiscrim); 
        // float t_0 = Q / A; 
        // float t_1 = C / Q;
        // t0 = min( t_0, t_1 );
        // t1 = max( t_0, t_1 );
        t1 = Q / A; 
        t0 = C / Q;
        
        return TRUE;
    } */
    // optimized algorithm for solving quadratic equations developed by Dr. Po-Shen Loh -> https://youtu.be/XKBX0r3J-9Y
    // Adapted to root finding (ray t0/t1) for all quadric shapes (sphere, ellipsoid, cylinder, cone, etc.) by Erich Loftis
    void solveQuadratic(float A, float B, float C, out float t0, out float t1)
    {
        float invA = 1.0 / A;
        B *= invA;
        C *= invA;
        float neg_halfB = -B * 0.5;
        float u2 = neg_halfB * neg_halfB - C;
        float u = u2 < 0.0 ? neg_halfB = 0.0 : sqrt(u2);
        t0 = neg_halfB - u;
        t1 = neg_halfB + u;
    }

    //-----------------------------------------------------------------------------
    float SphereIntersect2( float rad, vec3 pos, vec3 rayOrigin, vec3 rayDirection )
    //-----------------------------------------------------------------------------
    {
        float t0, t1;
        vec3 L = rayOrigin - pos;
        float a = dot( rayDirection, rayDirection );
        float sr = (rad * rad);
        float sl = dot( L, L );
        
        if(sl < sr)
            return sqrt(sl);

        float b = 2.0 * dot( rayDirection, L );
        float c = sl - sr;
        solveQuadratic(a, b, c, t0, t1);
        return t0 > 0.0 ? t0 : t1 > 0.0 ? t1 : INFINITY;
    }

    //-----------------------------------------------------------------------------
    float SphereIntersect( float rad, vec3 pos, vec3 rayOrigin, vec3 rayDirection, out int RayExiting)
    //-----------------------------------------------------------------------------
    {
        float t0, t1;
        vec3 L = rayOrigin - pos;
        float a = dot( rayDirection, rayDirection );
        float sr = (rad * rad);
        float sl = dot( L, L );
        float b = 2.0 * dot( rayDirection, L );
        float c = sl - sr;
        solveQuadratic(a, b, c, t0, t1);

        
        if (t0 > 0.0)
        {
            RayExiting = FALSE;
        }else if (t1 > 0.0)
        {
            RayExiting = TRUE;
        }

        return t0 > 0.0 ? t0 : t1 > 0.0 ? t1 : INFINITY;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_unit_bounding_sphere_intersect' ] = `

    float UnitBoundingSphereIntersect( vec3 ro, vec3 rd, out int insideSphere )
    {
        float t0, t1;
        float a = dot(rd, rd);
        float b = 2.0 * dot(rd, ro);
        float c = dot(ro, ro) - (1.01 * 1.01); // - (rad * rad) = - (1.0 * 1.0) = - 1.0 
        solveQuadratic(a, b, c, t0, t1);
        if (t0 > 0.0)
        {
            insideSphere = FALSE;
            return t0;
        }
        if (t1 > 0.0)
        {
            insideSphere = TRUE;
            return t1;
        }

        return INFINITY;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_unit_sphere_intersect' ] = `

    float UnitSphereIntersect( vec3 ro, vec3 rd, out vec3 n )
    {
        vec3 hitPoint;
        float t0, t1;
        float a = dot(rd, rd);
        float b = 2.0 * dot(rd, ro);
        float c = dot(ro, ro) - 1.0;// radius * radius = 1.0 * 1.0 = 1.0 
        solveQuadratic(a, b, c, t0, t1);
        
        // first, try t0
        if (t0 > 0.0)
        {
            hitPoint = ro + rd * t0;
            n = hitPoint;
            return t0;
        }
        // if t0 was invalid, try t1
        if (t1 > 0.0)
        {
            hitPoint = ro + rd * t1;
            n = hitPoint;
            return t1;
        }

        return 0.0;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_unit_cylinder_intersect' ] = `

    float UnitCylinderIntersect( vec3 ro, vec3 rd, out vec3 n )
    {
        vec3 hitPoint;
        float t0, t1;
        float a = rd.x * rd.x + rd.z * rd.z;
        float b = 2.0 * (rd.x * ro.x + rd.z * ro.z);
        float c = (ro.x * ro.x + ro.z * ro.z) - 0.99;// 0.99 prevents clipping at cylinder walls 
        solveQuadratic(a, b, c, t0, t1);
        
        // first, try t0
        hitPoint = ro + rd * t0;
        if (t0 > 0.0 && abs(hitPoint.y) <= 1.0)
        {
            n = vec3(hitPoint.x, 0.0, hitPoint.z);
            return t0;
        }
        // if t0 was invalid, try t1
        hitPoint = ro + rd * t1;
        if (t1 > 0.0 && abs(hitPoint.y) <= 1.0)
        {
            n = vec3(hitPoint.x, 0.0, hitPoint.z);
            return t1;
        }

        return 0.0;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_unit_cone_intersect' ] = `

    float UnitConeIntersect( vec3 ro, vec3 rd, out vec3 n )
    {
        // the '(ro.y - h)' parts below truncate the top half of the double-cone, leaving a single cone with apex at top
        vec3 hitPoint;
        float t0, t1;
        float h = 1.0;	      // 0.25 makes the circular base of cone end up as radius of 1, unit length
        float a = rd.x * rd.x - (0.25 * rd.y * rd.y) + rd.z * rd.z;
        float b = 2.0 * (rd.x * ro.x - (0.25 * rd.y * (ro.y - h)) + rd.z * ro.z);
        float c = ro.x * ro.x - (0.25 * (ro.y - h) * (ro.y - h)) + ro.z * ro.z;
        solveQuadratic(a, b, c, t0, t1);
        
        // first, try t0
        hitPoint = ro + rd * t0;
        if (t0 > 0.0 && abs(hitPoint.y) <= 1.0)
        {
            n = vec3(hitPoint.x, (h - hitPoint.y) * 0.25, hitPoint.z);
            return t0;
        }
        // if t0 was invalid, try t1
        hitPoint = ro + rd * t1;
        if (t1 > 0.0 && abs(hitPoint.y) <= 1.0)
        {
            n = vec3(hitPoint.x, (h - hitPoint.y) * 0.25, hitPoint.z);
            return t1;
        }

        return 0.0;
    }
    `;


    THREE.ShaderChunk[ 'pathtracing_opencylinder_intersect' ] = `
    //-------------------------------------------------------------------------------------------------------
    float OpenCylinderIntersect( vec3 p0, vec3 p1, float rad, vec3 rayOrigin, vec3 rayDirection, out vec3 n )
    //-------------------------------------------------------------------------------------------------------
    {
        float r2=rad*rad;
        
        vec3 dp=p1-p0;
        vec3 dpt=dp/dot(dp,dp);
        
        vec3 ao=rayOrigin-p0;
        vec3 aoxab=cross(ao,dpt);
        vec3 vxab=cross(rayDirection,dpt);
        float ab2=dot(dpt,dpt);
        float a=2.0*dot(vxab,vxab);
        float ra=1.0/a;
        float b=2.0*dot(vxab,aoxab);
        float c=dot(aoxab,aoxab)-r2*ab2;
        
        float det=b*b-2.0*a*c;
        
        if (det<0.0) 
            return INFINITY;
        
        det=sqrt(det);
        
        float t0 = (-b-det)*ra;
        float t1 = (-b+det)*ra;
        
        vec3 ip;
        vec3 lp;
        float ct;
        if (t0 > 0.0)
        {
            ip=rayOrigin+rayDirection*t0;
            lp=ip-p0;
            ct=dot(lp,dpt);
            if((ct>0.0)&&(ct<1.0))
            {
                n=ip-(p0+dp*ct);
                return t0;
            }
        }
        
        if (t1 > 0.0)
        {
            ip=rayOrigin+rayDirection*t1;
            lp=ip-p0;
            ct=dot(lp,dpt);
            if((ct>0.0)&&(ct<1.0))
            {
                    n=(p0+dp*ct)-ip;
                return t1;
            }
        }
        
        return INFINITY;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_cappedcylinder_intersect' ] = `
    //---------------------------------------------------------------------------------------------------------
    float CappedCylinderIntersect( vec3 p0, vec3 p1, float rad, vec3 rayOrigin, vec3 rayDirection, out vec3 n, out int isRayExiting )
    //---------------------------------------------------------------------------------------------------------
    {
        float r2=rad*rad;
        
        vec3 dp=p1-p0;
        vec3 dpt=dp/dot(dp,dp);
        
        vec3 ao=rayOrigin-p0;
        vec3 aoxab=cross(ao,dpt);
        vec3 vxab=cross(rayDirection,dpt);
        float ab2=dot(dpt,dpt);
        float a=2.0*dot(vxab,vxab);
        float ra=1.0/a;
        float b=2.0*dot(vxab,aoxab);
        float c=dot(aoxab,aoxab)-r2*ab2;
        
        float det=b*b-2.0*a*c;
        
        if(det<0.0)
            return INFINITY;
        
        det=sqrt(det);
        
        float t0=(-b-det)*ra;
        float t1=(-b+det)*ra;
        
        vec3 ip;
        vec3 lp;
        float ct;
        float result = INFINITY;
        
        // Cylinder caps
        // disk0
        vec3 diskNormal = normalize(dp);
        float denom = dot(diskNormal, rayDirection);
        vec3 pOrO = p0 - rayOrigin;
        float tDisk0 = dot(pOrO, diskNormal) / denom;
        if (tDisk0 > 0.0)
        {
            vec3 intersectPos = rayOrigin + rayDirection * tDisk0;
            vec3 v = intersectPos - p0;
            float d2 = dot(v,v);
            if (d2 <= r2)
            {
                if(t0 < tDisk0)
                    isRayExiting = TRUE;
                else
                    isRayExiting = FALSE;

                result = tDisk0;
                n = diskNormal;
            }
        }
        
        // disk1
        denom = dot(diskNormal, rayDirection);
        pOrO = p1 - rayOrigin;
        float tDisk1 = dot(pOrO, diskNormal) / denom;
        if (tDisk1 > 0.0)
        {
            vec3 intersectPos = rayOrigin + rayDirection * tDisk1;
            vec3 v = intersectPos - p1;
            float d2 = dot(v,v);
            if (d2 <= r2 && tDisk1 < result)
            {
                if(t0 < tDisk1)
                    isRayExiting = TRUE;
                else
                    isRayExiting = FALSE;

                result = tDisk1;
                n = diskNormal;
            }
        }
        
        // Cylinder body
        if (t1 > 0.0)
        {
            ip=rayOrigin+rayDirection*t1;
            lp=ip-p0;
            ct=dot(lp,dpt);
            if(ct>0.0 && ct<1.0 && t1<result)
            {
                result = t1;
                n=(p0+dp*ct)-ip;
                
                if(t0 < t1)
                    isRayExiting = TRUE;
                else
                    isRayExiting = FALSE;
            }
        }
        
        if (t0 > 0.0)
        {
            ip=rayOrigin+rayDirection*t0;
            lp=ip-p0;
            ct=dot(lp,dpt);
            if(ct>0.0 && ct<1.0 && t0<result)
            {
                result = t0;

                if(t1 < t0)
                    isRayExiting = TRUE;
                else
                    isRayExiting = FALSE;

                
                n=ip-(p0+dp*ct);
            }
        }
        
        return result;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_cone_intersect' ] = `
    //--------------------------------------------------------------------------------------------------------
    float ConeIntersect( vec3 p0, float r0, vec3 p1, float r1, vec3 rayOrigin, vec3 rayDirection, out vec3 n )
    //-------------------------------------------------------------------------------------------------------- 
    {
        r0 += 0.1;
        vec3 locX;
        vec3 locY;
        vec3 locZ=-(p1-p0)/(1.0 - r1/r0);
        
        rayOrigin-=p0-locZ;
        
        if(abs(locZ.x)<abs(locZ.y))
            locX=vec3(1,0,0);
        else
            locX=vec3(0,1,0);
            
        float len=length(locZ);
        locZ=normalize(locZ)/len;
        locY=normalize(cross(locX,locZ))/r0;
        locX=normalize(cross(locY,locZ))/r0;
        
        mat3 tm;
        tm[0]=locX;
        tm[1]=locY;
        tm[2]=locZ;
        
        rayDirection*=tm;
        rayOrigin*=tm;
        
        float dx=rayDirection.x;
        float dy=rayDirection.y;
        float dz=rayDirection.z;
        
        float x0=rayOrigin.x;
        float y0=rayOrigin.y;
        float z0=rayOrigin.z;
        
        float x02=x0*x0;
        float y02=y0*y0;
        float z02=z0*z0;
        
        float dx2=dx*dx;
        float dy2=dy*dy;
        float dz2=dz*dz;
        
        float det=(
            -2.0*x0*dx*z0*dz
            +2.0*x0*dx*y0*dy
            -2.0*z0*dz*y0*dy
            +dz2*x02
            +dz2*y02
            +dx2*z02
            +dy2*z02
            -dy2*x02
            -dx2*y02
            );
        
        if(det<0.0)
            return INFINITY;
            
        float t0=(-x0*dx+z0*dz-y0*dy-sqrt(abs(det)))/(dx2-dz2+dy2);
        float t1=(-x0*dx+z0*dz-y0*dy+sqrt(abs(det)))/(dx2-dz2+dy2);
        vec3 pt0=rayOrigin+t0*rayDirection;
        vec3 pt1=rayOrigin+t1*rayDirection;
        
        if(t0>0.0 && pt0.z>r1/r0 && pt0.z<1.0)
        {
            n=pt0;
            n.z=0.0;
            n=normalize(n);
            n.z=-pt0.z/abs(pt0.z);
            n=normalize(n);
            n=tm*n;
            return t0;
        }
            if(t1>0.0 && pt1.z>r1/r0 && pt1.z<1.0)
        {
            n=pt1;
            n.z=0.0;
            n=normalize(n);
            n.z=-pt1.z/abs(pt1.z);
            n=normalize(n);
            n=tm*-n;
            return t1;
        }
        
        return INFINITY;	
    }
    `;


    THREE.ShaderChunk[ 'pathtracing_capsule_intersect' ] = `
    //-----------------------------------------------------------------------------------------------------------
    float CapsuleIntersect( vec3 p0, float r0, vec3 p1, float r1, vec3 rayOrigin, vec3 rayDirection, out vec3 n )
    //-----------------------------------------------------------------------------------------------------------
    {
        /*
        // used for ConeIntersect below, if different radius sphere end-caps are desired
        vec3 l  = p1-p0;
        float ld = length(l);
        l=l/ld;
        float d= r0-r1;
        float sa = d/ld;
        float h0 = r0*sa;
        float h1 = r1*sa;
        float cr0 = sqrt(r0*r0-h0*h0);
        float cr1 = sqrt(r1*r1-h1*h1);
        vec3 coneP0=p0+l*h0;
        vec3 coneP1=p1+l*h1;
        */
        
        float t0=INFINITY;
            
        float t1;
        vec3 uv1;
        vec3 n1;
        //t1 = ConeIntersect(coneP0,cr0,coneP1,cr1,rayOrigin, rayDirection,n1);
        t1 = OpenCylinderIntersect(p0,p1,r0,rayOrigin, rayDirection,n1);
        if(t1<t0)
        {
            t0=t1;
            n=n1;
        }
        t1 = SphereIntersect(r0,p0,rayOrigin, rayDirection);
        if(t1<t0)
        {
            t0=t1;
            n=(rayOrigin + rayDirection * t1) - p0;
        }
        t1 = SphereIntersect(r1,p1,rayOrigin, rayDirection);
        if(t1<t0)
        {
            t0=t1;
            n=(rayOrigin + rayDirection * t1) - p1;
        }
            
        return t0;
    }
    `;


    THREE.ShaderChunk[ 'pathtracing_quad_intersect' ] = `
    float TriangleIntersect( vec3 v0, vec3 v1, vec3 v2, vec3 rayOrigin, vec3 rayDirection, int isDoubleSided )
    {
        vec3 edge1 = v1 - v0;
        vec3 edge2 = v2 - v0;
        vec3 pvec = cross(rayDirection, edge2);
        float det = 1.0 / dot(edge1, pvec);
        if ( isDoubleSided == FALSE && det < 0.0 ) 
            return INFINITY;
        vec3 tvec = rayOrigin - v0;
        float u = dot(tvec, pvec) * det;
        vec3 qvec = cross(tvec, edge1);
        float v = dot(rayDirection, qvec) * det;
        float t = dot(edge2, qvec) * det;
        return (u < 0.0 || u > 1.0 || v < 0.0 || u + v > 1.0 || t <= 0.0) ? INFINITY : t;
    }
    //--------------------------------------------------------------------------------------------------------------
    float QuadIntersect( vec3 v0, vec3 v1, vec3 v2, vec3 v3, vec3 rayOrigin, vec3 rayDirection, int isDoubleSided )
    //--------------------------------------------------------------------------------------------------------------
    {
        return min(TriangleIntersect(v0, v1, v2, rayOrigin, rayDirection, isDoubleSided), 
            TriangleIntersect(v0, v2, v3, rayOrigin, rayDirection, isDoubleSided));
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_box_intersect' ] = `
    //-----------------------------------------------------------------------------------------------------------------------------
    float BoxIntersect( vec3 minCorner, vec3 maxCorner, vec3 rayOrigin, vec3 rayDirection, out vec3 normal, out int isRayExiting )
    //-----------------------------------------------------------------------------------------------------------------------------
    {
        vec3 invDir = 1.0 / rayDirection;
        vec3 near = (minCorner - rayOrigin) * invDir;
        vec3 far  = (maxCorner - rayOrigin) * invDir;

        vec3 tmin = min(near, far);
        vec3 tmax = max(near, far);

        float t0 = max( max(tmin.x, tmin.y), tmin.z);
        float t1 = min( min(tmax.x, tmax.y), tmax.z);

        if (t0 > t1) return INFINITY;
        if (t0 > 0.0) // if we are outside the box
        {
            normal = -sign(rayDirection) * step(tmin.yzx, tmin) * step(tmin.zxy, tmin);
            isRayExiting = FALSE;
            return t0;
        }
        if (t1 > 0.0) // if we are inside the box
        {
            normal = -sign(rayDirection) * step(tmax, tmax.yzx) * step(tmax, tmax.zxy);
            isRayExiting = TRUE;
            return t1;
        }
        return INFINITY;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_box_interior_intersect' ] = `
    //--------------------------------------------------------------------------------------------------------------
    float BoxInteriorIntersect( vec3 minCorner, vec3 maxCorner, vec3 rayOrigin, vec3 rayDirection, out vec3 normal )
    //--------------------------------------------------------------------------------------------------------------
    {
        vec3 invDir = 1.0 / rayDirection;
        vec3 near = (minCorner - rayOrigin) * invDir;
        vec3 far  = (maxCorner - rayOrigin) * invDir;
        
        vec3 tmin = min(near, far);
        vec3 tmax = max(near, far);
        
        float t0 = max( max(tmin.x, tmin.y), tmin.z);
        float t1 = min( min(tmax.x, tmax.y), tmax.z);
        
        if (t0 > t1) return INFINITY;

        /*
        if (t0 > 0.0) // if we are outside the box
        {
            normal = -sign(rayDirection) * step(tmin.yzx, tmin) * step(tmin.zxy, tmin);
            return t0;	
        }
        */

        if (t1 > 0.0) // if we are inside the box
        {
            normal = -sign(rayDirection) * step(tmax, tmax.yzx) * step(tmax, tmax.zxy);
            return t1;
        }

        return INFINITY;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_boundingbox_intersect' ] = `
    //--------------------------------------------------------------------------------------
    float BoundingBoxIntersect( vec3 minCorner, vec3 maxCorner, vec3 rayOrigin, vec3 invDir )
    //--------------------------------------------------------------------------------------
    {
        vec3 near = (minCorner - rayOrigin) * invDir;
        vec3 far  = (maxCorner - rayOrigin) * invDir;
        
        vec3 tmin = min(near, far);
        vec3 tmax = max(near, far);
        
        float t0 = max( max(tmin.x, tmin.y), tmin.z);
        float t1 = min( min(tmax.x, tmax.y), tmax.z);
        
        return max(t0, 0.0) > t1 ? INFINITY : t0;
    }
    `;



    THREE.ShaderChunk[ 'pathtracing_bvhTriangle_intersect' ] = `
    //-------------------------------------------------------------------------------------------------------------------
    float BVH_TriangleIntersect( vec3 v0, vec3 v1, vec3 v2, vec3 rayOrigin, vec3 rayDirection, out float u, out float v )
    //-------------------------------------------------------------------------------------------------------------------
    {
        vec3 edge1 = v1 - v0;
        vec3 edge2 = v2 - v0;
        vec3 pvec = cross(rayDirection, edge2);
        float det = 1.0 / dot(edge1, pvec);
        vec3 tvec = rayOrigin - v0;
        u = dot(tvec, pvec) * det;
        vec3 qvec = cross(tvec, edge1);
        v = dot(rayDirection, qvec) * det;
        float t = dot(edge2, qvec) * det;
        return (det < 0.0 ||  u < 0.0 || u > 1.0 || v < 0.0 || u + v > 1.0 || t <= 0.0) ? INFINITY : t;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_bvhDoubleSidedTriangle_intersect' ] = `
    //------------------------------------------------------------------------------------------------------------------------------
    float BVH_DoubleSidedTriangleIntersect( vec3 v0, vec3 v1, vec3 v2, vec3 rayOrigin, vec3 rayDirection, out float u, out float v )
    //------------------------------------------------------------------------------------------------------------------------------
    {
        vec3 edge1 = v1 - v0;
        vec3 edge2 = v2 - v0;
        vec3 pvec = cross(rayDirection, edge2);
        float det = 1.0 / dot(edge1, pvec);
        vec3 tvec = rayOrigin - v0;
        u = dot(tvec, pvec) * det;
        vec3 qvec = cross(tvec, edge1);
        v = dot(rayDirection, qvec) * det; 
        float t = dot(edge2, qvec) * det;
        return (u < 0.0 || u > 1.0 || v < 0.0 || u + v > 1.0 || t <= 0.0) ? INFINITY : t;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_physical_sky_functions' ] = `
    float RayleighPhase(float cosTheta)
    {
        return THREE_OVER_SIXTEENPI * (1.0 + (cosTheta * cosTheta));
    }

    float hgPhase(float cosTheta, float g)
    {
            float g2 = g * g;
            float inverse = 1.0 / pow(max(0.0, 1.0 - 2.0 * g * cosTheta + g2), 1.5);
        return ONE_OVER_FOURPI * ((1.0 - g2) * inverse);
    }

    vec3 totalMie()
    {
        float c = (0.2 * TURBIDITY) * 10E-18;
        return 0.434 * c * MIE_CONST;
    }

    float SunIntensity(float zenithAngleCos)
    {
        zenithAngleCos = clamp( zenithAngleCos, -1.0, 1.0 );
        return SUN_POWER * max( 0.0, 1.0 - pow( E, -( ( CUTOFF_ANGLE - acos( zenithAngleCos ) ) / STEEPNESS ) ) );
    }

    vec3 Get_Sky_Color(vec3 rayDir)
    {
        vec3 viewDirection = normalize(rayDir);
        
        /* most of the following code is borrowed from the three.js shader file: SkyShader.js */
            // Cosine angles
        float cosViewSunAngle = dot(viewDirection, uSunDirection);
            float cosSunUpAngle = dot(UP_VECTOR, uSunDirection); // allowed to be negative: + is daytime, - is nighttime
            float cosUpViewAngle = dot(UP_VECTOR, viewDirection);
        
            // Get sun intensity based on how high in the sky it is
            float sunE = SunIntensity(cosSunUpAngle);
            
        // extinction (absorbtion + out scattering)
        // rayleigh coefficients
            vec3 rayleighAtX = TOTAL_RAYLEIGH * RAYLEIGH_COEFFICIENT;
        
        // mie coefficients
        vec3 mieAtX = totalMie() * MIE_COEFFICIENT;  
        
        // optical length
        float zenithAngle = acos( max( 0.0, dot( UP_VECTOR, viewDirection ) ) );
        float inverse = 1.0 / ( cos( zenithAngle ) + 0.15 * pow( 93.885 - ( ( zenithAngle * 180.0 ) / PI ), -1.253 ) );
        float rayleighOpticalLength = RAYLEIGH_ZENITH_LENGTH * inverse;
        float mieOpticalLength = MIE_ZENITH_LENGTH * inverse;
        // combined extinction factor	
        vec3 Fex = exp(-(rayleighAtX * rayleighOpticalLength + mieAtX * mieOpticalLength));
        // in scattering
        vec3 betaRTheta = rayleighAtX * RayleighPhase(cosViewSunAngle * 0.5 + 0.5);
        vec3 betaMTheta = mieAtX * hgPhase(cosViewSunAngle, MIE_DIRECTIONAL_G);
        
        vec3 Lin = pow( sunE * ( ( betaRTheta + betaMTheta ) / ( rayleighAtX + mieAtX ) ) * ( 1.0 - Fex ), vec3( 1.5 ) );
        Lin *= mix( vec3( 1.0 ), pow( sunE * ( ( betaRTheta + betaMTheta ) / ( rayleighAtX + mieAtX ) ) * Fex, vec3( 1.0 / 2.0 ) ), clamp( pow( 1.0 - cosSunUpAngle, 5.0 ), 0.0, 1.0 ) );
        // nightsky
        float theta = acos( viewDirection.y ); // elevation --> y-axis, [-pi/2, pi/2]
        float phi = atan( viewDirection.z, viewDirection.x ); // azimuth --> x-axis [-pi/2, pi/2]
        vec2 uv = vec2( phi, theta ) / vec2( 2.0 * PI, PI ) + vec2( 0.5, 0.0 );
        vec3 L0 = vec3( 0.1 ) * Fex;
        // composition + solar disc
        float sundisk = smoothstep( SUN_ANGULAR_DIAMETER_COS, SUN_ANGULAR_DIAMETER_COS + 0.00002, cosViewSunAngle );
        L0 += ( sunE * 19000.0 * Fex ) * sundisk;
        vec3 texColor = ( Lin + L0 ) * 0.04 + vec3( 0.0, 0.0003, 0.00075 );
        float sunfade = 1.0 - clamp( 1.0 - exp( ( uSunDirection.y / 450000.0 ) ), 0.0, 1.0 );
        vec3 retColor = pow( texColor, vec3( 1.0 / ( 1.2 + ( 1.2 * sunfade ) ) ) );
        return retColor;
    }
    `;



    THREE.ShaderChunk[ 'pathtracing_random_functions' ] = `
    // globals used in rand() function
    vec4 randVec4; // samples and holds the RGBA blueNoise texture value for this pixel
    float randNumber; // the final randomly generated number (range: 0.0 to 1.0)
    float counter; // will get incremented by 1 on each call to rand()
    int channel; // the final selected color channel to use for rand() calc (range: 0 to 3, corresponds to R,G,B, or A)
    float rand()
    {
        
        counter++;
        // cycles through channels, if modulus is 1.0, channel will always be 0 (the R color channel)
        channel = int(mod(counter, 2.0)); 
        // but if modulus was 4.0, channel will cycle through all available channels: 0,1,2,3,0,1,2,3, and so on...
        randNumber = randVec4[channel]; // get value stored in channel 0:R, 1:G, 2:B, or 3:A
        return fract(randNumber); // we're only interested in randNumber's fractional value between 0.0 (inclusive) and 1.0 (non-inclusive)
        //return clamp(randNumber,0.0,0.999999999); // we're only interested in randNumber's fractional value between 0.0 (inclusive) and 1.0 (non-inclusive)
    }
    // from iq https://www.shadertoy.com/view/4tXyWN
    // global seed used in rng() function
    uvec2 seed;
    float rng()
    {
        seed += uvec2(1);
            uvec2 q = 1103515245U * ( (seed >> 1U) ^ (seed.yx) );
            uint  n = 1103515245U * ( (q.x) ^ (q.y >> 3U) );
        return float(n) * (1.0 / float(0xffffffffU));
    }

    vec3 randomSphereDirection()
    {
            float up = rng() * 2.0 - 1.0; // range: -1 to +1
        float over = sqrt( max(0.0, 1.0 - up * up) );
        float around = rng() * TWO_PI;
        return normalize(vec3(cos(around) * over, up, sin(around) * over));	
    }
    
   
    vec3 randomDirectionInSpecularLobe(vec3 reflectionDir, float roughness)
    {
        float z = rng() * 2.0 - 1.0;
        float phi = rng() * TWO_PI;
        float r = sqrt(1.0 - z * z);
            vec3 cosDiffuseDir = normalize(reflectionDir + vec3(r * cos(phi), r * sin(phi), z));
        return normalize( mix(reflectionDir, cosDiffuseDir, roughness * roughness) );
    }

    /* vec3 randomDirectionInPhongSpecular(vec3 reflectionDir, float shininess)
    {
        float cosTheta = pow(rng(), 1.0 / (2.0 + shininess));
        float sinTheta = sqrt(1.0 - cosTheta * cosTheta);
        float phi = rng() * TWO_PI;
        float x = sinTheta * cos(phi);
        float y = sinTheta * sin(phi);
        vec3 T = normalize(cross(reflectionDir.yzx, reflectionDir));
        vec3 B = cross(reflectionDir, T);
        return normalize(T * x + B * y + reflectionDir * cosTheta);
    } */

    
    /*
     vec3 randomCosWeightedDirectionInHemisphere(vec3 nl)
    {
        float r0 = sqrt(rng());
        float phi = rng() * TWO_PI;
        float x = r0 * cos(phi);
        float y = r0 * sin(phi);
        float z = sqrt(1.0 - r0 * r0);
        vec3 T = normalize(cross(nl.yzx, nl));
        vec3 B = cross(nl, T);
        return normalize(T * x + B * y + nl * z);
    } 
    */
    
    //the following alternative skips the creation of tangent and bi-tangent vectors T and B
    vec3 randomCosWeightedDirectionInHemisphere(vec3 nl)
    {
        float z = rng() * 2.0 - 1.0;
        float phi = rng() * TWO_PI;
        float r = sqrt(1.0 - z * z);
            return normalize(nl + vec3(r * cos(phi), r * sin(phi), z));
    }
     
    /*
    // this is my crude attempt at a Fibonacci-spiral sample point pattern on a hemisphere above a diffuse surface
    #define N_POINTS 64.0 //64.0
    vec3 randomCosWeightedDirectionInHemisphere(vec3 nl)
    {
        float i = N_POINTS * rng();
                // the Golden angle in radians
        float phi = mod(i * 2.39996322972865332, TWO_PI);
        float r = sqrt(i / N_POINTS); // sqrt pushes points outward to prevent clumping in center of disk
        float x = r * cos(phi);
        float y = r * sin(phi);
        float z = sqrt(1.0 - r * r);
        
        vec3 U = normalize( cross( abs(nl.y) < 0.9 ? vec3(0, 1, 0) : vec3(0, 0, 1), nl ) );
        vec3 V = cross(nl, U);
        return normalize(x * U + y * V + z * nl);
    } 
    */
   
    /*
    // like the function several functions above, 
    // the following alternative skips the creation of tangent and bi-tangent vectors T and B 
    vec3 randomCosWeightedDirectionInHemisphere(vec3 nl)
    {
        float phi = rng() * TWO_PI;
        float theta = rng() * 2.0 - 1.0;
        return normalize(nl + vec3(sqrt(1.0 - theta * theta) * vec2(cos(phi), sin(phi)), theta));
    } 
    */

    `;

    THREE.ShaderChunk[ 'pathtracing_random_functions_racing' ] = `
    // globals used in rand() function
    vec4 randVec4; // samples and holds the RGBA blueNoise texture value for this pixel
    float randNumber; // the final randomly generated number (range: 0.0 to 1.0)
    float counter; // will get incremented by 1 on each call to rand()
    int channel; // the final selected color channel to use for rand() calc (range: 0 to 3, corresponds to R,G,B, or A)
    float rand()
    {
        counter++;
        // cycles through channels, if modulus is 1.0, channel will always be 0 (the R color channel)
        channel = int(mod(counter, 2.0)); 
        // but if modulus was 4.0, channel will cycle through all available channels: 0,1,2,3,0,1,2,3, and so on...
        randNumber = randVec4[channel]; // get value stored in channel 0:R, 1:G, 2:B, or 3:A
        return fract(randNumber); // we're only interested in randNumber's fractional value between 0.0 (inclusive) and 1.0 (non-inclusive)
        //return clamp(randNumber,0.0,0.999999999); // we're only interested in randNumber's fractional value between 0.0 (inclusive) and 1.0 (non-inclusive)
    }
    // from iq https://www.shadertoy.com/view/4tXyWN
    // global seed used in rng() function
    uvec2 seed;
    float rng()
    {
        
        seed += uvec2(1);
            uvec2 q = 1103515245U * ( (seed >> 1U) ^ (seed.yx) );
            uint  n = 1103515245U * ( (q.x) ^ (q.y >> 3U) );
        return float(n) * (1.0 / float(0xffffffffU));
    }

    vec3 randomSphereDirection()
    {
        float up = rng() * 2.0 - 1.0; // range: -1 to +1
        float over = sqrt( max(0.0, 1.0 - up * up) );
        float around = rng() * TWO_PI;
        return normalize(vec3(cos(around) * over, up, sin(around) * over));	
    }
    
   
    vec3 randomDirectionInSpecularLobe(vec3 reflectionDir, float roughness)
    {
        float z = 0.2;
        float phi = 0.5 * TWO_PI;
        float r = sqrt(1.0 - z * z);
            vec3 cosDiffuseDir = normalize(reflectionDir + vec3(r * cos(phi), r * sin(phi), z));
        return normalize( mix(reflectionDir, cosDiffuseDir, roughness * roughness) );
    }

    /* vec3 randomDirectionInPhongSpecular(vec3 reflectionDir, float shininess)
    {
        float cosTheta = pow(rng(), 1.0 / (2.0 + shininess));
        float sinTheta = sqrt(1.0 - cosTheta * cosTheta);
        float phi = rng() * TWO_PI;
        float x = sinTheta * cos(phi);
        float y = sinTheta * sin(phi);
        vec3 T = normalize(cross(reflectionDir.yzx, reflectionDir));
        vec3 B = cross(reflectionDir, T);
        return normalize(T * x + B * y + reflectionDir * cosTheta);
    } */

    
    /*
     vec3 randomCosWeightedDirectionInHemisphere(vec3 nl)
    {
        float r0 = sqrt(rng());
        float phi = rng() * TWO_PI;
        float x = r0 * cos(phi);
        float y = r0 * sin(phi);
        float z = sqrt(1.0 - r0 * r0);
        vec3 T = normalize(cross(nl.yzx, nl));
        vec3 B = cross(nl, T);
        return normalize(T * x + B * y + nl * z);
    } 
    */
    
    //the following alternative skips the creation of tangent and bi-tangent vectors T and B
    vec3 randomCosWeightedDirectionInHemisphere(vec3 nl)
    {
        float z = 0.5 * 2.0 - 1.0;
        float phi = 0.5 * TWO_PI;
        float r = sqrt(1.0 - z * z);
        return normalize(nl + vec3(r * cos(phi), r * sin(phi), z));
    }
     
    /*
    // this is my crude attempt at a Fibonacci-spiral sample point pattern on a hemisphere above a diffuse surface
    #define N_POINTS 64.0 //64.0
    vec3 randomCosWeightedDirectionInHemisphere(vec3 nl)
    {
        float i = N_POINTS * rng();
                // the Golden angle in radians
        float phi = mod(i * 2.39996322972865332, TWO_PI);
        float r = sqrt(i / N_POINTS); // sqrt pushes points outward to prevent clumping in center of disk
        float x = r * cos(phi);
        float y = r * sin(phi);
        float z = sqrt(1.0 - r * r);
        
        vec3 U = normalize( cross( abs(nl.y) < 0.9 ? vec3(0, 1, 0) : vec3(0, 0, 1), nl ) );
        vec3 V = cross(nl, U);
        return normalize(x * U + y * V + z * nl);
    } 
    */
   
    /*
    // like the function several functions above, 
    // the following alternative skips the creation of tangent and bi-tangent vectors T and B 
    vec3 randomCosWeightedDirectionInHemisphere(vec3 nl)
    {
        float phi = rng() * TWO_PI;
        float theta = rng() * 2.0 - 1.0;
        return normalize(nl + vec3(sqrt(1.0 - theta * theta) * vec2(cos(phi), sin(phi)), theta));
    } 
    */

    `;


    THREE.ShaderChunk[ 'pathtracing_sample_sphere_light' ] = `
    vec3 sampleSphereLight(vec3 x, vec3 nl, Light light, out float weight)
    {
        vec3 dirToLight = normalize(light.position - x); // no normalize (for distance calc below)

        weight = 0.5;

        return dirToLight;

        float cos_alpha_max = sqrt(1.0 - clamp((light.radius * light.radius) / dot(dirToLight, dirToLight), 0.0, 1.0));
        float r0 = rng();
        float cos_alpha = 1.0 - r0 + r0 * cos_alpha_max;//mix( cos_alpha_max, 1.0, rng() );
        // * 0.75 below ensures shadow rays don't miss smaller sphere lights, due to shader float precision
        float sin_alpha = sqrt(max(0.0, 1.0 - cos_alpha * cos_alpha)) * 0.75; 
        float phi = rng() * TWO_PI;
        dirToLight = normalize(dirToLight);
        
        vec3 U = normalize( cross( abs(dirToLight.y) < 0.9 ? vec3(0, 1, 0) : vec3(0, 0, 1), dirToLight ) );
        vec3 V = cross(dirToLight, U);
        
        vec3 sampleDir = normalize(U * cos(phi) * sin_alpha + V * sin(phi) * sin_alpha + dirToLight * cos_alpha);
        weight = clamp(2.0 * (1.0 - cos_alpha_max) * max(0.0, dot(nl, sampleDir)), 0.0, 1.0);
        
        return sampleDir;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_sample_quad_light' ] = `
    vec3 sampleQuadLight(vec3 x, vec3 nl, Quad light, out float weight)
    {
        vec3 randPointOnLight;
        randPointOnLight.x = mix(light.v0.x, light.v2.x, clamp(rng(), 0.1, 0.9));
        randPointOnLight.y = light.v0.y;
        randPointOnLight.z = mix(light.v0.z, light.v2.z, clamp(rng(), 0.1, 0.9));
        vec3 dirToLight = randPointOnLight - x;
        float r2 = distance(light.v0, light.v1) * distance(light.v0, light.v3);
        float d2 = dot(dirToLight, dirToLight);
        float cos_a_max = sqrt(1.0 - clamp( r2 / d2, 0.0, 1.0));
        dirToLight = normalize(dirToLight);
        float dotNlRayDir = max(0.0, dot(nl, dirToLight)); 
        weight =  2.0 * (1.0 - cos_a_max) * max(0.0, -dot(dirToLight, light.normal)) * dotNlRayDir; 
        weight = clamp(weight, 0.0, 1.0);
        return dirToLight;
    }
    `;

    THREE.ShaderChunk[ 'pathtracing_calc_fresnel_reflectance' ] = `
    float calcFresnelReflectance(vec3 rayDirection, vec3 n, float etai, float etat, out float ratioIoR)
    {
        float temp = etai;
        float cosi = clamp(dot(rayDirection, n), -1.0, 1.0);
        if (cosi > 0.0)
        {
            etai = etat;
            etat = temp;
        }
        
        ratioIoR = etai / etat;
        float sint2 = ratioIoR * ratioIoR * (1.0 - (cosi * cosi));
        if (sint2 >= 1.0) 
            return 1.0; // total internal reflection
        float cost = sqrt(1.0 - sint2);
        cosi = abs(cosi);
        float Rs = ((etat * cosi) - (etai * cost)) / ((etat * cosi) + (etai * cost));
        float Rp = ((etai * cosi) - (etat * cost)) / ((etai * cosi) + (etat * cost));
        return clamp( ((Rs * Rs) + (Rp * Rp)) * 0.5, 0.0, 1.0 );
    }
    `;

    /*
    THREE.ShaderChunk[ 'pathtracing_main_static' ] = `
    // tentFilter from Peter Shirley's 'Realistic Ray Tracing (2nd Edition)' book, pg. 60
    float tentFilter(float x) // input: x: a random float(0.0 to 1.0), output: a filtered float (-1.0 to +1.0)
    {
        return (x < 0.5) ? sqrt(2.0 * x) - 1.0 : 1.0 - sqrt(2.0 - (2.0 * x));
    }

    void main( void )
    {
        vec3 camRight   = vec3( uCameraMatrix[0][0],  uCameraMatrix[0][1],  uCameraMatrix[0][2]);
        vec3 camUp      = vec3( uCameraMatrix[1][0],  uCameraMatrix[1][1],  uCameraMatrix[1][2]);
        vec3 camForward = vec3(-uCameraMatrix[2][0], -uCameraMatrix[2][1], -uCameraMatrix[2][2]);
        // the following is not needed - three.js has a built-in uniform named cameraPosition
        //vec3 camPos   = vec3( uCameraMatrix[3][0],  uCameraMatrix[3][1],  uCameraMatrix[3][2]);

        // calculate unique seed for rng() function
        seed = uvec2(uFrameCounter, uFrameCounter + 1.0) * uvec2(gl_FragCoord);
        // initialize rand() variables
        counter = -1.0; // will get incremented by 1 on each call to rand()
        channel = 0; // the final selected color channel to use for rand() calc (range: 0 to 3, corresponds to R,G,B, or A)
        randNumber = 0.0; // the final randomly-generated number (range: 0.0 to 1.0)
        randVec4 = vec4(0); // samples and holds the RGBA blueNoise texture value for this pixel
        randVec4 = texelFetch(tBlueNoiseTexture, ivec2(mod(floor(gl_FragCoord.xy) + floor(uRandomVec2 * 256.0), 256.0)), 0);
        
        // rand() produces higher FPS and almost immediate convergence, but may have very slight jagged diagonal edges on higher frequency color patterns, i.e. checkerboards.
        // rng() has a little less FPS on mobile, and a little more noisy initially, but eventually converges on perfect anti-aliased edges - use this if 'beauty-render' is desired.
        vec2 pixelOffset;

        if (uFrameCounter < 150.0) 
            pixelOffset = vec2( tentFilter(rand()), tentFilter(rand()) );
        else 
            pixelOffset = vec2( tentFilter(rng()), tentFilter(rng()) );
        
        // we must map pixelPos into the range -1.0 to +1.0: (-1.0,-1.0) is bottom-left screen corner, (1.0,1.0) is top-right
        vec2 pixelPos = ((gl_FragCoord.xy + pixelOffset) / uResolution) * 2.0 - 1.0;
        vec3 rayDir = uUseOrthographicCamera ? camForward : normalize( pixelPos.x * camRight * uULen + pixelPos.y * camUp * uVLen + camForward ); 
                                    
        // depth of field
        
        vec3 focalPoint = uFocusDistance * rayDir;
        
        float randomAngle = rng() * TWO_PI; // pick random point on aperture
        float randomRadius = rng() * 10.0;
        vec3  randomAperturePos = ( cos(randomAngle) * camRight + sin(randomAngle) * camUp ) * sqrt(randomRadius);
        // point on aperture to focal point
        vec3 finalRayDir = normalize(focalPoint - randomAperturePos);

        rayOrigin = cameraPosition;
        rayOrigin += !uUseOrthographicCamera ? vec3(0) : (camRight * pixelPos.x * uULen * 100.0) + (camUp * pixelPos.y * uVLen * 100.0);
                            
        rayDirection = finalRayDir;


        // Edge Detection - don't want to blur edges where either surface normals change abruptly (i.e. room wall corners), objects overlap each other (i.e. edge of a foreground sphere in front of another sphere right behind it),
        // or an abrupt color variation on the same smooth surface, even if it has similar surface normals (i.e. checkerboard pattern). Want to keep all of these cases as sharp as possible - no blur filter will be applied.
        vec3 objectNormal = vec3(0);
        vec3 objectColor = vec3(0);
        float objectID = -INFINITY;
        float pixelSharpness = 1.0;

        // perform path tracing and get resulting pixel color
        vec4 currentPixel = vec4( vec3(CalculateRadiance(objectNormal, objectColor, objectID, pixelSharpness)), 0.0 );


        // if difference between normals of neighboring pixels is less than the first edge0 threshold, the white edge line effect is considered off (0.0)
        float edge0 = 0.2; // edge0 is the minimum difference required between normals of neighboring pixels to start becoming a white edge line
        // any difference between normals of neighboring pixels that is between edge0 and edge1 smoothly ramps up the white edge line brightness (smoothstep 0.0-1.0)
        float edge1 = 0.6; // once the difference between normals of neighboring pixels is >= this edge1 threshold, the white edge line is considered fully bright (1.0)
        float difference_Nx = fwidth(objectNormal.x);
        float difference_Ny = fwidth(objectNormal.y);
        float difference_Nz = fwidth(objectNormal.z);
        float normalDifference = smoothstep(edge0, edge1, difference_Nx) + smoothstep(edge0, edge1, difference_Ny) + smoothstep(edge0, edge1, difference_Nz);

        float objectDifference = min(fwidth(objectID), 1.0);

        float colorDifference = (fwidth(objectColor.r) + fwidth(objectColor.g) + fwidth(objectColor.b)) > 0.0 ? 1.0 : 0.0;
        // white-line debug visualization for normal difference
        //currentPixel.rgb += (rng() * 1.5) * vec3(normalDifference);
        // white-line debug visualization for object difference
        //currentPixel.rgb += (rng() * 1.5) * vec3(objectDifference);
        // white-line debug visualization for color difference
        //currentPixel.rgb += (rng() * 1.5) * vec3(colorDifference);
        // white-line debug visualization for all 3 differences
        
        //currentPixel.rgb += (rng() * 1.5) * vec3( clamp(max(normalDifference, max(objectDifference, colorDifference)), 0.0, 1.0) );
        
        vec4 previousPixel = texelFetch(tPreviousTexture, ivec2(gl_FragCoord.xy), 0);
        
        if (uFrameCounter == 1.0) // camera just moved after being still
        {
            previousPixel.rgb *= (1.0 / uPreviousSampleCount) * 0.5; // essentially previousPixel *= 0.5, like below
            previousPixel.a = 0.0;
            currentPixel.rgb *= 0.5;
        }
        else if (uCameraIsMoving) // camera is currently moving
        {
            previousPixel.rgb *= 0.5; // motion-blur trail amount (old image)
            previousPixel.a = 0.0;
            currentPixel.rgb *= 0.5; // brightness of new image (noisy)
        }

        // if current raytraced pixel didn't return any color value, just use the previous frame's pixel color
        if (currentPixel.rgb == vec3(0.0))
        {
            currentPixel.rgb = previousPixel.rgb;
            previousPixel.rgb *= 0.5;
            currentPixel.rgb *= 0.5;
        }

        if (colorDifference >= 1.0 || normalDifference >= 1.0 || objectDifference >= 1.0)
            pixelSharpness = 1.01;

        currentPixel.a = pixelSharpness;

        // Eventually, all edge-containing pixels' .a (alpha channel) values will converge to 1.01, which keeps them from getting blurred by the box-blur filter, thus retaining sharpness.

        if (previousPixel.a == 1.01)
            currentPixel.a = 1.01;
        

        pc_fragColor = vec4(previousPixel.rgb + currentPixel.rgb, currentPixel.a);
    }
    `;
    

    THREE.ShaderChunk[ 'pathtracing_main_race' ] = `
    // tentFilter from Peter Shirley's 'Realistic Ray Tracing (2nd Edition)' book, pg. 60
    float tentFilter(float x) // input: x: a random float(0.0 to 1.0), output: a filtered float (-1.0 to +1.0)
    {
        return (x < 0.5) ? sqrt(2.0 * x) - 1.0 : 1.0 - sqrt(2.0 - (2.0 * x));
    }

    void main( void )
    {
        vec3 camRight   = vec3( uCameraMatrix[0][0],  uCameraMatrix[0][1],  uCameraMatrix[0][2]);
        vec3 camUp      = vec3( uCameraMatrix[1][0],  uCameraMatrix[1][1],  uCameraMatrix[1][2]);
        vec3 camForward = vec3(-uCameraMatrix[2][0], -uCameraMatrix[2][1], -uCameraMatrix[2][2]);
        // the following is not needed - three.js has a built-in uniform named cameraPosition
        //vec3 camPos   = vec3( uCameraMatrix[3][0],  uCameraMatrix[3][1],  uCameraMatrix[3][2]);

        // calculate unique seed for rng() function
        seed = uvec2(uFrameCounter, uFrameCounter + 1.0) * uvec2(gl_FragCoord);
        // initialize rand() variables
        counter = -1.0; // will get incremented by 1 on each call to rand()
        channel = 0; // the final selected color channel to use for rand() calc (range: 0 to 3, corresponds to R,G,B, or A)
        randNumber = 0.0; // the final randomly-generated number (range: 0.0 to 1.0)
        randVec4 = vec4(0); // samples and holds the RGBA blueNoise texture value for this pixel
        randVec4 = texelFetch(tBlueNoiseTexture, ivec2(mod(floor(gl_FragCoord.xy) + floor(uRandomVec2 * 256.0), 256.0)), 0);
        
        // rand() produces higher FPS and almost immediate convergence, but may have very slight jagged diagonal edges on higher frequency color patterns, i.e. checkerboards.
        // rng() has a little less FPS on mobile, and a little more noisy initially, but eventually converges on perfect anti-aliased edges - use this if 'beauty-render' is desired.
        vec2 pixelOffset;

        
        //if (uFrameCounter < 150.0) 
        //    pixelOffset = vec2( tentFilter(rand()), tentFilter(rand()) );
        //else 

            pixelOffset = vec2( tentFilter(rng()), tentFilter(rng()) );
        
        // we must map pixelPos into the range -1.0 to +1.0: (-1.0,-1.0) is bottom-left screen corner, (1.0,1.0) is top-right
        vec2 pixelPos = ((gl_FragCoord.xy + pixelOffset) / uResolution) * 2.0 - 1.0;
        vec3 rayDir = uUseOrthographicCamera ? camForward : normalize( pixelPos.x * camRight * uULen + pixelPos.y * camUp * uVLen + camForward ); 
                                    
        // depth of field

        
        vec3 focalPoint = uFocusDistance * rayDir;

        
        //float randomAngle = rng() * TWO_PI; // pick random point on aperture
        //float randomRadius = rng() * 10.0;
        //vec3  randomAperturePos = ( cos(randomAngle) * camRight + sin(randomAngle) * camUp ) * sqrt(randomRadius);
        // point on aperture to focal point
        //vec3 finalRayDir = normalize(focalPoint - randomAperturePos);
        
        
        vec3 finalRayDir = normalize(focalPoint);

        rayOrigin = cameraPosition;
        rayOrigin += !uUseOrthographicCamera ? vec3(0) : (camRight * pixelPos.x * uULen * 100.0) + (camUp * pixelPos.y * uVLen * 100.0);
                            
        rayDirection = finalRayDir;

        // Edge Detection - don't want to blur edges where either surface normals change abruptly (i.e. room wall corners), objects overlap each other (i.e. edge of a foreground sphere in front of another sphere right behind it),
        // or an abrupt color variation on the same smooth surface, even if it has similar surface normals (i.e. checkerboard pattern). Want to keep all of these cases as sharp as possible - no blur filter will be applied.
        vec3 objectNormal = vec3(0);
        vec3 objectColor = vec3(0);
        float objectID = -INFINITY;
        float pixelSharpness = 1.0;

        // perform path tracing and get resulting pixel color
        vec4 currentPixel = vec4( vec3(CalculateRadiance(objectNormal, objectColor, objectID, pixelSharpness)), 0.0 );
        /*
        // if difference between normals of neighboring pixels is less than the first edge0 threshold, the white edge line effect is considered off (0.0)
        float edge0 = 0.2; // edge0 is the minimum difference required between normals of neighboring pixels to start becoming a white edge line
        // any difference between normals of neighboring pixels that is between edge0 and edge1 smoothly ramps up the white edge line brightness (smoothstep 0.0-1.0)
        float edge1 = 0.6; // once the difference between normals of neighboring pixels is >= this edge1 threshold, the white edge line is considered fully bright (1.0)
        float difference_Nx = fwidth(objectNormal.x);
        float difference_Ny = fwidth(objectNormal.y);
        float difference_Nz = fwidth(objectNormal.z);
        float normalDifference = smoothstep(edge0, edge1, difference_Nx) + smoothstep(edge0, edge1, difference_Ny) + smoothstep(edge0, edge1, difference_Nz);

        float objectDifference = min(fwidth(objectID), 1.0);

        float colorDifference = (fwidth(objectColor.r) + fwidth(objectColor.g) + fwidth(objectColor.b)) > 0.0 ? 1.0 : 0.0;
        // white-line debug visualization for normal difference
        //currentPixel.rgb += (rng() * 1.5) * vec3(normalDifference);
        // white-line debug visualization for object difference
        //currentPixel.rgb += (rng() * 1.5) * vec3(objectDifference);
        // white-line debug visualization for color difference
        //currentPixel.rgb += (rng() * 1.5) * vec3(colorDifference);
        // white-line debug visualization for all 3 differences
        
        //currentPixel.rgb += (rng() * 1.5) * vec3( clamp(max(normalDifference, max(objectDifference, colorDifference)), 0.0, 1.0) );

       
        vec4 previousPixel = texelFetch(tPreviousTexture, ivec2(gl_FragCoord.xy), 0);
        
        if (uFrameCounter == 1.0) // camera just moved after being still
        {
            previousPixel.rgb *= (1.0 / uPreviousSampleCount) * 0.5; // essentially previousPixel *= 0.5, like below
            previousPixel.a = 0.0;
            currentPixel.rgb *= 0.5;
        }
        else if (uCameraIsMoving) // camera is currently moving
        {
            previousPixel.rgb *= 0.5; // motion-blur trail amount (old image)
            previousPixel.a = 0.0;
            currentPixel.rgb *= 0.5; // brightness of new image (noisy)
        }

        // if current raytraced pixel didn't return any color value, just use the previous frame's pixel color
        if (currentPixel.rgb == vec3(0.0))
        {
            currentPixel.rgb = previousPixel.rgb;
            previousPixel.rgb *= 0.5;
            currentPixel.rgb *= 0.5;
        }

        if (colorDifference >= 1.0 || normalDifference >= 1.0 || objectDifference >= 1.0)
            pixelSharpness = 1.01;

        

        // Eventually, all edge-containing pixels' .a (alpha channel) values will converge to 1.01, which keeps them from getting blurred by the box-blur filter, thus retaining sharpness.

        if (previousPixel.a == 1.01)
            currentPixel.a = 1.01;
        
        *
        currentPixel.a = pixelSharpness;
        pc_fragColor = currentPixel;
    }
    `;
    */
}




export {initShaders};

